export const warmupServer = () => {
  fetch('https://elite-goats.onrender.com/api/health')
    .catch(() => {}); // silent — just wakes the server
};